import React from 'react';
import { Page } from './Page';

export const NotFoundPage = () => <Page title="Page Not Found">{null}</Page>;
